export default "/build/images/1foot.png?b61230af06707dd7fc09c5e756cf5ba5";